import { useEffect } from 'react';

import { useLatest } from 'shared/common/hooks/useLatest';
import { ECalculatorEventName } from 'shared/common/utils';

export interface IUseCalculatorResetEventDeps {
  eventTarget: HTMLFormElement | null;
  onReset: () => void;
}

const isResetEventForForm = (event: Event, form: HTMLFormElement): boolean => {
  const target = event.target;

  if (!(target instanceof Element)) {
    return false;
  }

  return target === form || target.contains(form) || form.contains(target);
};

export const useCalculatorResetEvent = ({ eventTarget, onReset }: IUseCalculatorResetEventDeps) => {
  const onResetRef = useLatest(onReset);
  const eventTargetRef = useLatest(eventTarget);

  useEffect(() => {
    const handleReset = (event: Event) => {
      const form = eventTargetRef.current;

      if (!form || !isResetEventForForm(event, form)) {
        return;
      }

      onResetRef.current();
    };

    document.addEventListener(ECalculatorEventName.onReset, handleReset, true);

    return () => {
      document.removeEventListener(ECalculatorEventName.onReset, handleReset, true);
    };
  }, [eventTargetRef, onResetRef]);
};
